import isString from 'lodash/isString';
export const _isString = isString;
